import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

class PostGridCollection extends Component {
    static propTypes = {
        title: PropTypes.string,
        defaultExpanded: PropTypes.bool.isRequired,
        isExpandable: PropTypes.bool.isRequired,
        posts: PropTypes.arrayOf(PropTypes.element)
    };

    static defaultProps = {
        defaultExpanded: false,
        isExpandable: true
    };

    constructor(props) {
        super(props);

        this.state = {
            expanded: props.defaultExpanded
        };
    }

    /**
     * @param {Event} e
     * @memberof PostGridCollection
     */
    toggleExpanded = e => {
        e.preventDefault();

        this.setState({expanded: !this.state.expanded});
    };
    
    titleText() {
        const {title, posts, isExpandable} = this.props;

        if (R.isNil(title)) {
            return null;
        }

        const postCount = R.length(posts);

        const dividerClass = isExpandable ? 'col-xs-3' : 'col-xs-4';

        return (
            <>
                <div className="col-xs-4">
                    <hr className="posts-grid-collection-title-divider" />
                </div>
                <div className="col-xs-4 posts-grid-collection-title-text">
                    {title} {`(${postCount})`}
                </div>
                <div className={dividerClass}>
                    <hr className="posts-grid-collection-title-divider" />
                </div>
            </>
        );
    }

    titleSection() {
        const {isExpandable} = this.props;
        const {expanded} = this.state;
        const titleText = this.titleText();

        if (R.isNil(titleText)) {
            return null;
        }

        const chevronClass = expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right';

        return isExpandable ?
                (
                    <a className="text-center posts-grid-collection-title"
                       href="#"
                       onClick={this.toggleExpanded}>
                        {titleText}
                        <div className="col-xs-1">
                            <i className={chevronClass} />
                        </div>
                    </a>
                ) : (
                    <div className="text-center posts-grid-collection-title">
                        {titleText}
                    </div>
                );
    }

    postSection() {
        const {expanded} = this.state;
        const {posts} = this.props;

        if (expanded) {
            return posts;
        }

        return null;
    }

    render() {
        const title = this.titleSection();
        const posts = this.postSection();

        if (R.isEmpty(this.props.posts)) {
            return <div />;
        }

        return (
            <div className="post-grid-collection">
                <div className="row">{title}</div>

                <div className="analytics-grid-component">{posts}</div>
            </div>
        );
    }
}

export default PostGridCollection;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/post_grid/post_grid_collection.js